const getState = (state) => state.app.layout;

export const isLoading = (state, currentUrl) => {
  const { loading } = state.app.layout;
  return (
    Object.values(loading).filter((val) => {
      if (val.urls.length === 0 && val.loading) {
        return true;
      }
      if (val.urls.includes(currentUrl) && val.loading) {
        return true;
      }
      return false;
    }).length > 0
  );
};

export const getContainerDimensions = (state) => getState(state).container;

export const getCurrentPageTitle = (state) => getState(state).currentPageTitle;

export const getMessages = (state) => {};

export const isBlocked = (state) => {
  const blocked = Object.values(getState(state).blocked);

  return blocked.length > 0 && blocked.filter((block) => block === true).length > 0;
};
